import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DocmanFolderModel } from '../services/docman.model.folder';
import { UiService } from '../../../core/services/core.ui.service';
import * as _ from 'lodash';

@Component({
  selector: 'folder-rename-modal',
  template: require('./folder.rename.modal.html')
})
export class FolderRenameModalComponent implements OnInit {
  @Input() folder: any;

  @Output() onRename = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  formErrors: any;

  constructor(
    private docmanFolderModel: DocmanFolderModel,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
  }

  renameFolder(): void | Promise<void> {
    let success = false;
    const folderCopy = _.clone(this.folder);

    // Validate folder first
    this.formErrors = this.docmanFolderModel.validateFolder(this.folder);
    if (!_.isEmpty(this.formErrors)) {
      this.uiService.message.showError('Folder validation failed. The folder name cannot contain slashes');
      return;
    }

    folderCopy.project = this.folder.project.id;

    return this.docmanFolderModel.saveFolder(folderCopy, false)
      .then(
        (response) => {
          success = true;
          this.uiService.message.showSuccess(`Folder settings for ${_.get(this.folder, 'folderName', '(unknown)')} have been updated successfully`);
          this.onRename.emit(this.folder);
        },
        (err) => {
          let msg = '';
          if (err.data?.folderName?.length > 0) {
            if (err.data.folderName[0].type === 'required') {
              msg = 'Folder name is required';
            } else if (err.data.folderName[0].type === 'length') {
              msg = 'Folder name must have at least 5 characters';
            }
          }
          this.uiService.message.showError(`Error saving folder ${_.get(this.folder, 'folderName', '(unknown)')}: ${msg}`);
          this.onClose.emit();
        }
      );
  }
}
